<template>
  <transition v-on:after-leave="afterLeave">
    <div
      v-show="show"
      class="snackbar"
      @click="close">
      <div class="snackbar_message">
        {{msg}}
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'snackbar',
  data () {
    return {
      msg: '',
      duration: 3000,
      show: true,
      timer: null
    }
  },
  mounted () {
    this.timer = setTimeout(() => {
      this.clear()
    }, this.duration)
  },
  methods: {
    clear () {
      this.show = false
      clearTimeout(this.timer)
    },
    close () {
      this.$destroy(true)
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el)
    },
    afterLeave () {
      this.close()
    }
  }
}
</script>

<style scoped>
.snackbar {
  position: fixed;
  bottom: 60px;
  z-index: 11000;
  display: flex;
  justify-content: center;
  width: 100%;
}

.snackbar_message {
  box-sizing: border-box;
  width: 80%;
  max-width: 370px;
  padding: 12px 20px;
  margin-top: 20px;
  font-size: 16px;
  color: #fff;
  background: #3a3a3aa6;
  border-radius: 10vw;
}

.v-enter,
.v-leave-to {
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity  0.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/snackbar/snackbar.vue